import React from 'react'
import { Card, CardHeader, CardBody } from 'reactstrap';

export default function CustomFields({customFields}) {

return (
  <Card>
    <CardHeader>
      <h2 className="card-header-title">Custom Fields</h2>
    </CardHeader>
    <CardBody>
      <div className="list-group list-group-flush">
        {
          customFields?.map((fieldName, idx) =>
            <div className="list-group-item" key={idx}>
              <div className="row align-items-center">
                <div className="col ml-n2">{fieldName}</div>
              </div>
            </div>
          )
        }
      </div>
    </CardBody>
  </Card>
)
}
